// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NbAS","top":"styles_top__3ygj4","left":"styles_left__3WSKu","description":"styles_description__3YXn-"};